<template>
	<div class="certification">
		<div class="module-title">患者认证</div>
		<div class="certification_title_form">
			<base-input
				v-model="patientName"
				placeholder="请输入患者姓名"
				class="patient_name"
				clearable
				show-border
				@clear="() => patientName = ''"
			/>
			<base-input
				v-model="patientCard"
				placeholder="请输入患者身份证"
				class="patient_idcard"
				maxlength="18"
				clearable
				show-border
				@clear="() => patientCard = ''"
			/>
			<p class="desc">*患者身份证信息仅用于档案创建与医生绑定，我们将对其进行严格保密</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'certification',
		props: {
			pName: {
				type: String,
				default: ''
			},
			pCard: {
				type: String,
				default: ''
			}
		},
		computed: {
			patientName: {
				get () {
					return this.pName
				},
				set (val) {
					this.$emit('update:pName', val)
				}
			},
			patientCard: {
				get () {
					return this.pCard
				},
				set (val) {
					this.$emit('update:pCard', val)
				}
			}
		}
	};
</script>

<style scoped lang="less">
	.certification {
		.certification_title_form {
			.patient_name { margin-top: 22px; }
			.patient_idcard { margin-top: 32px; }
			.desc {
				margin-top: 40px;
				font-family: PingFangSC-Regular;
				font-size: 26px;
				font-weight: normal;
				letter-spacing: 0px;
				color: #BBBFC4;
			}
		}
	}
</style>
